import { ProductItemPropsType } from '.';

export const ProductTicketItemProps: ProductItemPropsType = {
	CartListItemProp: {
		size: undefined,
	},
	nameTypographyProps: {
		variant: 'h6',
	},
	subNameTypographyProps: {
		variant: 'body2',
		color: 'primary',
	},
	quantityTypographyProps: {
		variant: 'h5',
	},
	quantityChangeTypographyProps: {
		variant: 'body2',
	},
	priceTypographyProps: {
		variant: 'h5',
	},
	unitPriceTypographyProps: {
		variant: 'body2',
		color: 'primary',
	},
};
